/**
 * How far off a guide line the cursor may be and still snap onto it — the
 * drawing tool's line snap and the corner move's angle snap share it, so a
 * guide pulls the same distance in both.
 *
 * A guide is a line, so its reach is a DISTANCE: an angle tolerance on its own
 * grows with the line's length, and on a long wall 5° is the better part of a
 * metre.
 */
export const LINE_SNAP_TOLERANCE_M = 0.15;
